import { CommonModule } from '@angular/common';
import { Component, type ElementRef, type QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { ICellEditorAngularComp } from 'ag-grid-angular';
import type { ICellEditorParams } from 'ag-grid-community';

@Component({
  standalone: true,
  templateUrl: './custom-date.component.html',
  styleUrls: ['./custom-date.component.scss'],
  imports: [CommonModule, FormsModule],
})
export class CustomDateComponent implements ICellEditorAngularComp {
  @ViewChildren('inputs') inputs: QueryList<ElementRef<HTMLInputElement>>;

  day: number;
  month: number;
  year: number;
  hour: number;
  min: number;

  agInit(params: ICellEditorParams) {
    const date: Date = params.value;

    if (date) {
      this.year = date.getUTCFullYear();
      this.month = date.getUTCMonth() + 1;
      this.day = date.getUTCDate();
      this.hour = date.getUTCHours();
      this.min = date.getUTCMinutes();
    }

    setTimeout(() => {
      this.inputs.toArray()[0].nativeElement.focus();
    });
  }

  getValue(): Date {
    for (const field of [this.day, this.month, this.year]) {
      if (!Number.isInteger(field)) {
        return;
      }
    }
    if (this.year.toString().length != 4) {
      return;
    }
    const month = this.month.toString().padStart(2, '0');
    const day = this.day.toString().padStart(2, '0');
    const hour = this.hour?.toString().padStart(2, '0') ?? '00';
    const min = this.min?.toString().padStart(2, '0') ?? '00';
    const isoString = `${this.year}-${month}-${day}T${hour}:${min}:00.000Z`;
    return new Date(isoString);
  }

  /** Stop propagation to AG Grid and stay within the HTML form. */
  onKeyDown(event: KeyboardEvent, position: 'start' | 'end' = null) {
    if (event.key === 'Tab') {
      if ((position === 'start' && event.shiftKey) || (position === 'end' && !event.shiftKey)) {
        return;
      }
      event.stopPropagation();
    }
  }

  autoNext(index: number, maxLength: number, event: InputEvent) {
    if (event.inputType === 'insertText') {
      const inputs = this.inputs.toArray();
      if (inputs[index].nativeElement.value.length >= maxLength) {
        inputs[index + 1].nativeElement.focus();
      }
    }
  }
}
